import React from 'react';

import Icon from '../Icon/Icon';

const PreferenceCenterIcon = (props) => {
    return (
        <Icon width='32' height='32' fill='none' {...props}>
            <path
                d='M25.7576 6.64293C18.5787 3.76506 14.4361 3.8064 6.85103 6.64293C5.54641 17.0885 7.71298 21.6164 16.1468 27.5977C25.3026 21.8906 26.6748 16.9669 25.7576 6.64293Z'
                fill='#393E44'
                stroke='#00D1D2'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12 15.25L15.5535 18.8143L21.5 11.5'
                stroke='#FFFDFB'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default PreferenceCenterIcon;
